import { PropsWithChildren, Children, ReactElement, ReactNode } from 'react'
import classNames from 'classnames'

interface FlexProps {
  readonly isCol?: boolean
  readonly flex?: number
  readonly justifyContent?: 'center' | 'flex-start' | 'flex-end'
  readonly justifySelf?: 'center' | 'flex-start' | 'flex-end'
  readonly alignItems?: 'center' | 'flex-start' | 'flex-end' | 'stretch'
  readonly alignSelf?: 'center' | 'flex-start' | 'flex-end'
  readonly className?: string
  readonly direction?: 'column' | 'row'
  children?: any
  readonly style?: any
}

type Props = PropsWithChildren<FlexProps>

export const Flexbox = (props: Props): ReactElement => {
  const {
    alignItems,
    alignSelf,
    children,
    className,
    direction,
    flex,
    isCol,
    justifyContent,
    justifySelf,
    style,
  } = props

  return (
    <div
      style={{
        flex: flex || undefined,
        justifyContent,
        alignItems,
        flexDirection: direction,
        alignSelf,
        justifySelf,
        ...style,
      }}
      className={classNames(
        {
          flex: true,
          column: isCol,
        },
        className,
      )}>
      {children}
    </div>
  )
}